import React from 'react'

const SubscriptionStatus = () => {
  return (
    <div>
      under construction
    </div>
  )
}

export default SubscriptionStatus
